// extracted by mini-css-extract-plugin
module.exports = {"DingTalkAuthWrapper":"DingTalkCodeLogin_DingTalkAuthWrapper__3Xnnq","DingTalkAuthCodeFrame":"DingTalkCodeLogin_DingTalkAuthCodeFrame__3GOqY"};